import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "step2-row"
};
const _hoisted_2 = {
  class: "step2-row"
};
const _hoisted_3 = {
  key: 0,
  class: "error-message"
};
import { reactive, ref } from "vue";
import informationService from "@/utils/information";
export default {
  __name: 'information-form',
  props: {
    form: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      required: true
    }
  },
  emits: ["update:form", "update:form-blur"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const formRef = ref(null);
    const emailError = ref(false);
    const emit = __emit;
    const validate = () => {
      return formRef.value?.validate();
    };
    __expose({
      validate
    });
    const isFocused = reactive({
      firstName: false,
      lastName: false,
      email: false,
      phone: false
    });
    const handleFormBlur = () => {
      isFocused.email = false;
      validateEmail();
      isFocused.firstName = false;
      isFocused.lastName = false;
      isFocused.phone = false;
      emit("update:form-blur");
    };
    const validateEmail = () => {
      if (!props.form.email) {
        emailError.value = false;
        return;
      }
      const emailRegex = new RegExp(informationService.emailRex);
      emailError.value = !emailRegex.test(props.form.email);
    };
    const handleEmailChange = val => {
      emailError.value = false;
      emit("update:form", {
        ...props.form,
        email: val
      });
    };
    const handlePhoneChange = val => {
      if (!val) {
        emit("update:form", {
          ...props.form,
          phone: ""
        });
        return;
      }
      const numericValue = val.replace(/[^\d]/g, "");
      const formattedPhone = informationService.formatPhone(numericValue);
      emit("update:form", {
        ...props.form,
        phone: formattedPhone
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_component_el_form, {
        class: "step2-form",
        ref_key: "formRef",
        ref: formRef,
        model: __props.form,
        rules: __props.rules
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form_item, {
          prop: "firstName",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.firstName || __props.form.firstName
          }])
        }, {
          default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "float-label"
          }, "First Name", -1)), _createVNode(_component_el_input, {
            "model-value": __props.form.firstName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.$emit('update:form', {
              ...__props.form,
              firstName: val
            })),
            onFocus: _cache[1] || (_cache[1] = $event => isFocused.firstName = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, null, 8, ["model-value"])]),
          _: 1,
          __: [6]
        }, 8, ["class"]), _createVNode(_component_el_form_item, {
          prop: "lastName",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.lastName || __props.form.lastName
          }])
        }, {
          default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "float-label"
          }, "Last Name", -1)), _createVNode(_component_el_input, {
            "model-value": __props.form.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.$emit('update:form', {
              ...__props.form,
              lastName: val
            })),
            onFocus: _cache[3] || (_cache[3] = $event => isFocused.lastName = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, null, 8, ["model-value"])]),
          _: 1,
          __: [7]
        }, 8, ["class"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
          prop: "email",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.email || __props.form.email,
            'is-error': emailError.value
          }])
        }, {
          default: _withCtx(() => [_createElementVNode("label", {
            class: _normalizeClass(["float-label", {
              'is-error': emailError.value
            }])
          }, "Email Address", 2), _createVNode(_component_el_input, {
            "model-value": __props.form.email,
            "onUpdate:modelValue": handleEmailChange,
            onFocus: _cache[4] || (_cache[4] = $event => isFocused.email = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, null, 8, ["model-value"]), emailError.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Please enter a valid email address ")) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["class"]), _createVNode(_component_el_form_item, {
          prop: "phone",
          class: _normalizeClass(["float-label-input", {
            'is-focused': isFocused.phone || __props.form.phone
          }])
        }, {
          default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("label", {
            class: "float-label"
          }, "Phone Number", -1)), _createVNode(_component_el_input, {
            "model-value": __props.form.phone,
            "onUpdate:modelValue": handlePhoneChange,
            onFocus: _cache[5] || (_cache[5] = $event => isFocused.phone = true),
            onBlur: handleFormBlur,
            class: "float-el-input",
            placeholder: "",
            clearable: ""
          }, {
            prefix: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("span", {
              class: "phone-code"
            }, "+1", -1)])),
            _: 1
          }, 8, ["model-value"])]),
          _: 1,
          __: [9]
        }, 8, ["class"])])]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
};